<template>
  <div name="stdapplinf-detail-pg3">
    <hrms-table :columns="columns" :data="data" :maxRowspan="2" />
  </div>
</template>

<script>
export default {
  name: 'stdapplinf-detail-pg3',
  props: [ 'labels', 'data', 'columns' ]
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg3.vue?1d7f225e